import {SxProps, Theme} from '@mui/material';
import {addActionButtonSx} from 'src/components/common/actionButton.sx';

/** The same add button every other list has, at the filter bar's height. */
export const addReManagerButtonSx = (_theme: Theme): SxProps<Theme> => addActionButtonSx('2rem');

export const formSx = (theme: Theme): SxProps<Theme> => ({
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: theme.spacing(20 / 8),
    padding: theme.spacing(20 / 8),
});

export const actionsWrapperSx = (theme: Theme): SxProps<Theme> => ({
    padding: theme.spacing(20 / 8, 24 / 8),
    borderTop: `${theme.spacing(1 / 8)} solid ${theme.palette.neutral[200]}`,
    background: theme.palette.neutral[50],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(20 / 8),
});
